<template lang="html">
  <img class="" src="@/assets/logo.svg" alt="logo" width="250" />
  <h2 class="title">
    Na ontvangst van de bovenstaande gegevens kan Rodi mogelijk nader contact
    met je opnemen. <br />
    Ik ga akkoord met de verwerking van mijn persoonlijke gegevens zoals
    beschreven in het
    <a
      href="https://www.rodi.nl/privacyverklaring"
      target="_blank"
      class="text-primary"
      >privacybeleid</a
    >
  </h2>

  <div class="d-grid gap-2">
    <button
      type="button"
      class="btn btn-secondary btn-lg rounded-0"
      @click="saveQuestionGdpr()"
    >
      <span>I agree</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "QuestionGdprScreen",
  data: () => ({}),
  computed: {},
  methods: {
    addRemoveAnswer(answer) {
      if (this.checkedAnswers.indexOf(answer) !== -1) {
        this.checkedAnswers.splice(this.checkedAnswers.indexOf(answer), 1);
      } else {
        this.checkedAnswers.push(answer);
      }
    },
    answerChecked(answer) {
      if (this.checkedAnswers.indexOf(answer) !== -1) {
        return true;
      }
      return false;
    },
    saveQuestionGdpr() {
      this.$store.commit("setQuestionGdpr", "true");
      let data = {};
      data.vendor = process.env.VUE_APP_VENDOR;
      data.first_name = this.$store.getters.getFirstName;
      data.last_name = this.$store.getters.getLastName;
      data.phone = this.$store.getters.getPhone;
      data.email = this.$store.getters.getEmail;
      data.company = this.$store.getters.getCompany;
      data.jobposition = this.$store.getters.getJobposition;
      data.question_1 = this.$store.getters.getQuestionOne;
      data.question_2 = this.$store.getters.getQuestionTwo;
      data.question_3 = this.$store.getters.getQuestionThree;
      data.question_4 = this.$store.getters.getQuestionFour;
      data.scanned = false;
      this.$store.dispatch("saveVisitor", data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/custom.scss";
h1 {
  font-size: 40px;
  color: $primary;
}
h2 {
  font-size: 25px;
  color: $primary !important;
}
.bg-field {
  color: $primary !important;
}
</style>
